import utils from '@/utils/utils'

import VueScroll from 'vue-scrollto'

const InfoTabs = {
  data() {
    return {
      activePanel: this.getData('infoTab'),
      breakpoint: 736,
      isMobile: false,
      lastWidth: window.innerWidth,
    }
  },
  methods: {
    getData: function (key) {
      const searchString = utils.getSearchString()
      const queryStringParams = new URLSearchParams(searchString)

      // Get data from search string else set it to default (1)
      const data =
        !queryStringParams.get(key) || queryStringParams.get(key).length < 1
          ? 0
          : parseInt(queryStringParams.get(key))

      return data
    },
    updateQueryString: function () {
      const key = 'infoTab'
      const searchString = utils.getSearchString()
      const queryStringParams = new URLSearchParams(searchString)

      if (this.activePanel === null && this.isMobile) {
        queryStringParams.delete(key)
      } else {
        const value = !this.activePanel ? 0 : this.activePanel
        queryStringParams.set(key, value)
      }

      const newURL =
        window.location.origin +
        window.location.pathname +
        '?' +
        queryStringParams.toString()
      window.history.replaceState({ path: newURL }, '', newURL)
    },
    handleResize(windowSize) {
      if (windowSize.width === this.lastWidth) {
        return // ignore height-only changes
      }
      this.lastWidth = windowSize.width

      const wasMobile = this.isMobile

      if (windowSize.width > this.breakpoint) {
        this.isMobile = false
        this.activePanel = this.activePanel != null ? this.activePanel : 0
      } else {
        this.isMobile = true
        // Only close tabs when transitioning FROM desktop TO mobile, not when already on mobile
        if (!wasMobile) {
          this.activePanel = null
        }
      }
      this.updateQueryString()
    },
    handleClick(id) {
      if (this.activePanel != id) {
        this.activePanel = parseInt(id)
      } else if (this.isMobile) {
        this.activePanel = null
      }

      this.updateQueryString()
    },
    scrollToTop() {
      const infoTabs = this.$refs.info_tabs

      VueScroll.scrollTo(infoTabs, 400, {
        offset: -160,
      })
    },
  },
  created() {
    bus.$on('info_tabs_scroll', () => {
      this.scrollToTop()
    })
    bus.$on('window_resize', windowSize => {
      this.handleResize(windowSize)
    })
  },
}

export default InfoTabs
